import { SuppressedDefaultActionLink, Tag } from "@snapchat/web-core-ui";
import { getClassName } from "@snapchat/web-sds-c";
import { incrementCounter } from "@snapchat/web-graphene-reporting";
import { useEffect, useRef } from "react";
import { FormattedMessage } from "react-intl";
import { LENS_CATEGORY } from "../../../constants/categories";
import { grafanaBasePrefix } from "../../../lib/grafana";
import { CreatorsGrid } from "./CreatorsGrid";
import { LensGrid } from "./LensGrid";
import styles from "./TopLensesGrid.module.css";
import _throttle from "lodash/throttle";
import { getWindow } from "@snapchat/web-env";
function getNextPageUrl(props) {
    const categoryPath = props.category && props.category.name !== LENS_CATEGORY.FOR_YOU
        ? `category/${props.category.name.toLowerCase()}`
        : "";
    return props.nextCursorId
        ? `${props.basePath}/${categoryPath}?cursor_id=${props.nextCursorId}`
        : `${props.basePath}/`;
}
function topLensesGridStyle(props) {
    if (props.isMobile) {
        return styles.mobileTitleContainer;
    }
    return styles.titleContainer;
}
function getTitleMessage(props) {
    if (!props.category) {
        return (<FormattedMessage description="A category label shown above a feed of popular lenses." defaultMessage="Top Lenses and Filters"/>);
    }
    switch (props.category.name) {
        case LENS_CATEGORY.FOR_YOU:
            return (<FormattedMessage description="A category label shown above a feed of popular lenses in the For You category." defaultMessage="Top Lenses and Filters on Snapchat"/>);
        case LENS_CATEGORY.TRENDING:
            return (<FormattedMessage description="A category label shown above a feed of popular lenses in the Trending category." defaultMessage="Trending Lenses and Filters on Snapchat"/>);
        case LENS_CATEGORY.CREATORS:
            return (<FormattedMessage description="A category label shown above a feed of popular lens creators." defaultMessage="Top Lens and Filter Creators on Snapchat"/>);
        case LENS_CATEGORY.WEB_LIVE:
            return (<FormattedMessage description="A category label shown above a feed of supported live lenses." defaultMessage="Top Live Lenses on Snapchat"/>);
        default:
            return (<FormattedMessage description="A category label shown above a feed of popular lenses in a category." defaultMessage="Top Lenses and Filters on Snapchat tagged with {displayName}" values={{ displayName: props.category.displayName }}/>);
    }
}
export function TopLensesGrid(props) {
    const scrollListenerRef = useRef(null);
    /* istanbul ignore next : Remove once test code is added */
    useEffect(() => {
        const handleScroll = _throttle(() => {
            if (scrollListenerRef.current) {
                // Call the getter function and pass it the current scroll position
                scrollListenerRef.current.className = `${styles.loadMoreButton} ${styles.button}`;
            }
        }, 400);
        getWindow()?.addEventListener("scroll", handleScroll);
        return () => {
            getWindow()?.removeEventListener("scroll", handleScroll);
        };
    }, []);
    const tagMessage = (<span className={getClassName("H6", true)}>
      {props.category?.name === LENS_CATEGORY.CREATORS ? (<FormattedMessage description="Message on the button to load the next page of lens creators on the Lens Homepage" defaultMessage="See more Lens Creators"/>) : (<FormattedMessage description="Message on the button to load the next page of lenses on the Lens Homepage" defaultMessage="See more Lenses"/>)}
    </span>);
    /* istanbul ignore next : Remove once test code is added */
    const incrementLoadMoreButtonClick = async () => {
        // default category is For You
        const categoryName = props.category?.name || LENS_CATEGORY.FOR_YOU;
        await incrementCounter(`${grafanaBasePrefix}.${props.pageName}.Lenses.LoadMoreButton.Click.${categoryName}`, 1);
    };
    return (<div className={props.isMobile ? styles.mobileGridContainer : styles.gridContainer}>
      <div className={topLensesGridStyle(props)}>
        <h1 className={getClassName("H6", true)}>
          <span className={styles.title} data-testid="toplensGridheading">
            {getTitleMessage(props)}
          </span>
        </h1>
      </div>
      {props.category && props.category.name === LENS_CATEGORY.CREATORS ? (<CreatorsGrid creators={props.creatorDisplayInfos}/>) : (<LensGrid lenses={props.topLenses} enableLargePreview={props.enableLargePreview} enableVideoPreview={props.enableVideoPreview}/>)}
      {props.hasMore && (<div ref={scrollListenerRef} data-testid="lensPaginationLoadMoreButton" className={styles.button}>
          <span className={styles.link}>
            <SuppressedDefaultActionLink link={getNextPageUrl(props)} logMetric={incrementLoadMoreButtonClick}>
              <Tag isSelected={false} text={tagMessage}/>
            </SuppressedDefaultActionLink>
          </span>
        </div>)}
    </div>);
}
